import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { ScrollReveal } from './ScrollAnimations';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/blog/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'newsletter_section' })
      });

      const data = await response.json();
      
      if (data.success) {
        setSubscribed(true);
        toast.success(data.message);
        setEmail('');
      } else {
        toast.error('Une erreur est survenue');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-accent/10 via-transparent to-accent/10" />
      <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(0, 255, 209, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255, 107, 0, 0.1) 0%, transparent 50%)'
      }} />
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <div className="max-w-2xl mx-auto text-center">
          <ScrollReveal animation="fadeUp">
            <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Mail className="text-accent" size={28} />
            </div>
            
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Restez informé des dernières tendances SEO
            </h2>
            
            <p className="text-white/60 mb-8">
              Recevez nos meilleurs conseils, guides exclusifs et actualités du référencement 
              directement dans votre boîte mail. Pas de spam, promis.
            </p>
          </ScrollReveal>

          <ScrollReveal animation="fadeUp" delay={200}>
            {subscribed ? (
              <div className="flex items-center justify-center gap-3 text-accent">
                <CheckCircle size={24} />
                <span className="text-lg font-medium">Merci pour votre inscription !</span>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.com"
                  required
                  className="flex-1 bg-white/5 border border-white/10 px-6 py-4 text-white placeholder:text-white/40 focus:outline-none focus:border-accent transition-colors"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="group px-8 py-4 bg-accent text-black font-medium hover:bg-accent/90 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <div className="w-5 h-5 border-2 border-black/30 border-t-black rounded-full animate-spin" />
                  ) : (
                    <>
                      S'inscrire
                      <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                    </>
                  )}
                </button>
              </form>
            )}
          </ScrollReveal>

          <ScrollReveal animation="fadeUp" delay={300}>
            <p className="text-white/40 text-sm mt-6">
              +500 professionnels nous font déjà confiance
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
